import React from 'react'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import { Highlighted } from '../../root/components/common/highlighted'

export default function HotSwapShowDeviceLabel(props) {
    const { deviceQuantity, search } = props

    const { locale } = useSelector(state => state.main)

    const showLabel = useMemo(() => {
        if (deviceQuantity > 1) {
            return `${deviceQuantity} ${locale.locations.devices}`
        }

        return `${deviceQuantity} ${locale.detachedSharing.device}`
    }, [deviceQuantity])

    return (
        <Typography noWrap variant="inherit">
            <Highlighted text={showLabel} highlight={search} />
        </Typography>
    )
}
